import React, { useEffect, useState } from 'react';
import {Upload, Button, message, List, Input, Spin, Row, Col} from "antd";
import { PageContainer } from '@ant-design/pro-components';
import { UploadOutlined, DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import {baseBackendUrl} from "../../shared/constants";
import MarkdownRenderer from "../../components/MarkdownRenderer";
import {fetchContent, fetchImages, saveMarkdownContent, uploadImage, deleteImages} from "../../components/Welcome";

const WelcomeManagement = () => {
    const [viewMode, setViewMode] = useState(true);
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);
    const [markdown, setMarkdown] = useState("");

    useEffect(() => {
        fetchWelcomeImages();
        fetchMarkdown();
    }, []);

    const fetchWelcomeImages = async () => {
        try {
            const data = await fetchImages();
            setImages(data);
        } catch (error) {
            message.error("Ошибка загрузки изображений");
        }
    };

    const fetchMarkdown = async () => {
        try {
            const data = await fetchContent();
            setMarkdown(data.content);
            setLoading(false);
        } catch (error) {
            message.error("Ошибка загрузки Markdown");
        }
    };

    const handleUpload = async ({ file }) => {
        const formData = new FormData();
        formData.append("image", file);
        try {
            await uploadImage(formData);
            fetchWelcomeImages();
        } catch (error) {
            message.error("Ошибка загрузки изображения");
        }
    };

    const handleDeleteImage = async (filename) => {
        try {
            await deleteImages(filename);
            fetchWelcomeImages();
        } catch (error) {
            message.error("Ошибка удаления изображения");
        }
    };

    const saveMarkdown = async () => {
        try {
            await saveMarkdownContent(markdown);
        } catch (error) {
            message.error("Ошибка сохранения Markdown");
        }
    };

    if (loading) return <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />;

    return (
        <PageContainer title="Welcome" content="Редактирование страницы Welcome (интерфейс администратора)">
            <Button onClick={() => setViewMode(prev => !prev)} style={{ marginBottom: 10 }}>
                {viewMode ? "Редактировать" : "Просмотр"}
            </Button>
            <Row>
                {viewMode ? (
                    <Col span={24}>
                        <div style={{ border: "1px solid #ddd", padding: "10px", borderRadius: "5px" }}>
                            <MarkdownRenderer content={markdown} />
                        </div>
                    </Col>
                ) : (
                    <Col span={24}>
                        <Input.TextArea
                            value={markdown}
                            onChange={(e) => setMarkdown(e.target.value)}
                            rows={10}
                            placeholder="Отредактируйте Markdown‑содержание"
                            autoSize={{ minRows: 3, maxRows: 90 }}
                        />
                    </Col>
                )}
                <Button type="primary" icon={<SaveOutlined />} onClick={saveMarkdown} style={{ marginTop: 10 }}>
                    Сохранить контент
                </Button>
            </Row>
            <h3>Изображения для слайдера</h3>
            <Upload customRequest={handleUpload} showUploadList={false}>
                <Button icon={<UploadOutlined />}>Загрузить изображение</Button>
            </Upload>
            <List
                dataSource={images}
                renderItem={(image) => (
                    <List.Item
                        actions={[
                            <Button
                                icon={<DeleteOutlined />}
                                danger
                                onClick={() => handleDeleteImage(image)}
                            >
                                Удалить
                            </Button>,
                        ]}
                    >
                        <img src={`${baseBackendUrl}${image}`} alt="preview" style={{ width: 100, marginRight: 10 }} />
                        {image.filename}
                        {image}
                    </List.Item>
                )}
            />
        </PageContainer>
    );
};

export default WelcomeManagement;